<div class="card">
    <div class="card-body">
        <ng-container *ngIf="!loading; else loadingTemplate">
            <div class="row">
                <div class="col">
                    <ul class="list-group">
                        <li class="list-group-item" *ngFor="let file of files">
                            <div class="row">
                                <div class="col-1 align-middle">
                                    <ng-container [ngSwitch]="file.fileName.substr(file.fileName.lastIndexOf('.') + 1)">
                                        <span *ngSwitchCase="'pdf'" class="align-middle">
                                            <fa-icon [icon]="icons['faFilePdf']" size="3x"></fa-icon>
                                        </span>
                                        <span *ngSwitchCase="'docx'" class="align-middle">
                                            <fa-icon [icon]="icons['faFileWord']" size="3x"></fa-icon>
                                        </span>
                                        <span *ngSwitchCase="'xlsx'" class="align-middle">
                                            <fa-icon [icon]="icons['faFileWord']" size="3x"></fa-icon>
                                        </span>
                                        <span *ngSwitchDefault class="align-middle">
                                            <fa-icon [icon]="icons['faFileImage']" size="3x"></fa-icon>
                                        </span>
                                    </ng-container>
                                </div>
                                <div class="col align-middle">
                                    <h6 class="align-middle mb-0 mt-3"> {{file.fileName}}</h6>
                                </div>
                                <div class="col text-end">
                                    <button type="button" class="btn btn-danger btn-sm mt-2">
                                        <fa-icon [icon]="icons['faTrashAlt']" (click)="deleteVssFile(file.id)">
                                        </fa-icon>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <label class="form-label">{{'VSS.FILES.uploadTitle' | translate}}</label>
                    <div class="input-group input-group-sm">
                        <input type="file" class="form-control" id="inputGroupFile04"
                            aria-describedby="inputGroupFileAddon04" aria-label="Upload"
                            (change)="handleImageFileInput($event)">
                        <button class="btn btn-outline-secondary" type="button" id="inputGroupFileAddon04"
                            (click)="uploadFile()">
                            {{'VSS.FILES.uploadFile' | translate}}
                        </button>
                    </div>
                    <small class="help-text text-danger" style="display: block;" *ngIf="fileSizeError">
                        {{'VSS.FILES.fileSizeError' | translate}}
                    </small>
                    <small class="help-text text-danger" style="display: block;" *ngIf="missingFileError">
                        {{'VSS.FILES.missingFileError' | translate}}
                    </small>
                    <small class="help-text text-danger" style="display: block;" *ngIf="regExError">
                        {{'VSS.FILES.regExError' | translate}}
                    </small>
                    <small class="text-muted">{{'VSS.FILES.uploadHelpText' | translate}}</small>
                </div>
            </div>
        </ng-container>
        <ng-template #loadingTemplate>
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </ng-template>
    </div>
</div>
<app-confirm-modal #confirmModal></app-confirm-modal>
